import React, { useState, useEffect, FC } from "react";
import IdvSlider from "./slider";
import { IdvOPTIONS } from "@utils/index";
import { useDispatch } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import IdvInputBox from "./slider/inputBox";
import { setAnalytics } from "@actions/setAnalyticsData";

export interface Idv {
  min: number;
  max: number;
  recommended: number;
  selected: number;
  type: string;
}

interface IdvSelectorProps {
  idv: Idv;
  showRecommendedRange?: boolean;
}

export const getFormattedIdv = (idv: Idv) => ({
  min: parseInt(idv?.min?.toString(), 10),
  max: parseInt(idv?.max?.toString(), 10),
  current: parseInt(idv?.selected?.toString(), 10),
  breakpoint: parseInt(idv?.recommended?.toString(), 10),
  recommendedIdv: parseInt(idv?.recommended?.toString(), 10)
});

const IdvSelector: FC<IdvSelectorProps> = ({
  idv,
  showRecommendedRange = false
}) => {
  const dispatch = useDispatch();
  const { min, max, current, recommendedIdv } = getFormattedIdv(idv);
  const [selectedValue, setSelectedValue] = useState<number>(current);
  const [sliderInteracted, setSliderInteracted] = useState<boolean>(false);
  const [sliderInteractionValue, setSliderInteractionValue] =
    useState<number>(current);

  useEffect(() => {
    setSelectedValue(current);
  }, [current]);

  useEffect(() => {
    if (selectedValue) {
      dispatch(
        setPayloadData({
          selected_idv: selectedValue,
          selected_idv_type: IdvOPTIONS.custom
        })
      );
      setAnalytics({
        selected_idv: selectedValue,
        selected_idv_type: IdvOPTIONS.custom
      });
    }
  }, [selectedValue, sliderInteracted]);

  return (
    <div>
      <IdvInputBox
        selectedIdv={selectedValue}
        setSelectedIdv={setSelectedValue}
        minIdv={min}
        maxIdv={max}
        recommendedIdv={recommendedIdv}
      />
      <IdvSlider
        min={min}
        max={max}
        selectedValue={selectedValue}
        setSelectedValue={setSelectedValue}
        setSliderInteracted={setSliderInteracted}
        singleRow={true}
        threshHold={recommendedIdv}
        setSliderInteractionValue={setSliderInteractionValue}
        showRecommendedRange={showRecommendedRange}
      />
    </div>
  );
};

export default IdvSelector;
